/* ==========================================================
   DOCUMENT READY
   ========================================================== */
$(document).ready(function () {

  /* ======================================================
     Lenis Smooth Scroll
     ====================================================== */
  let lenis = null;
  if (typeof Lenis !== "undefined") {
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
      infinite: false
    });

    lenis.on("scroll", function () {
      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.update();
      }
    });

    if (typeof gsap !== "undefined") {
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    } else {
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }

    window.lenis = lenis;
  }

  /* ======================================================
     AOS (Animate On Scroll)
     ====================================================== */
  if (typeof AOS !== "undefined") {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 100,
      delay: 250  
    });
  }

  /* ======================================================
     Site Preloader Fade-out
     ====================================================== */
  function hidePreloader() {
    const $preloader = $("#spPreloader");
    if ($preloader.length && !$preloader.hasClass("loaded")) {
      $preloader.addClass("loaded");
      setTimeout(function () {
        $preloader.remove();
        if (typeof AOS !== "undefined") {
          AOS.refresh();
        }
        if (typeof ScrollTrigger !== "undefined") {
          ScrollTrigger.refresh();
        }
        if (window.lenis) {
          window.lenis.resize();
        }
      }, 400);
      if (typeof playHeroTitle === "function") {
        setTimeout(playHeroTitle, 150);
      }
    } else if (typeof playHeroTitle === "function") {
      playHeroTitle();
    }
  }

  $(window).on("load", hidePreloader);
  // Fallback: show page after 800ms max regardless of load state
  setTimeout(hidePreloader, 800);



  /* ======================================================
     GSAP Stagger Text Animation & Dynamic Hero Slider
     ====================================================== */
  let playHeroTitle = function () { };

  if (typeof gsap !== "undefined") {
    if (typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
    }

    // 1. Dynamic Hero Slider & Staggered Elements Animation
    const $heroSliders = $(".hero-swiper");

    if ($heroSliders.length > 0 && typeof Swiper !== "undefined") {
      $heroSliders.each(function () {
        const $swiperContainer = $(this);
        const swiperEl = this;
        const $heroSection = $swiperContainer.closest(".hero-section");
        const autoplaySpeed = parseInt($heroSection.attr("data-autoplay-speed") || $heroSection.data("autoplay-speed")) || 6000;
        const rawAutoplay = $heroSection.attr("data-autoplay");
        const autoplayEnabled = rawAutoplay !== "false" && rawAutoplay !== false && $heroSection.data("autoplay") !== false && $heroSection.data("autoplay") !== "false";
        const effectType = $heroSection.data("effect") || "fade";
        const $slides = $swiperContainer.find(".hero-slide");
        const slideCount = $slides.length;

        // Split titles in each slide
        const slideSplits = new Map();
        if (typeof SplitType !== "undefined") {
          $slides.each(function () {
            const titleEl = this.querySelector(".hero-title");
            if (titleEl) {
              const split = new SplitType(titleEl, { types: "words, chars" });
              if (split.chars && split.chars.length) {
                slideSplits.set(this, split);
                gsap.set(split.chars, { x: 35, opacity: 0 });
              }
            }
          });
        }

        let animationTimeouts = [];

        function clearSlideTimeouts() {
          animationTimeouts.forEach(function (t) {
            clearTimeout(t);
          });
          animationTimeouts = [];
        }

        function resetSlide(slideEl) {
          if (!slideEl) return;
          const split = slideSplits.get(slideEl);
          if (split && split.chars && split.chars.length) {
            gsap.killTweensOf(split.chars);
            gsap.set(split.chars, { x: 35, opacity: 0 });
          }
          const badgeEl = slideEl.querySelector(".hero-floating-badge");
          if (badgeEl) badgeEl.classList.remove("is-animated");
          const subTitleEl = slideEl.querySelector(".sub-title");
          if (subTitleEl) subTitleEl.classList.remove("is-animated");
          const descEl = slideEl.querySelector(".hero-desc");
          if (descEl) descEl.classList.remove("is-animated");
          const btnGroupEl = slideEl.querySelector(".hero-btn-group");
          if (btnGroupEl) btnGroupEl.classList.remove("is-animated");
        }

        function triggerSlideAnimation(slideEl) {
          if (!slideEl) return;
          clearSlideTimeouts();

          const split = slideSplits.get(slideEl);
          const badgeEl = slideEl.querySelector(".hero-floating-badge");
          const subTitleEl = slideEl.querySelector(".sub-title");
          const descEl = slideEl.querySelector(".hero-desc");
          const btnGroupEl = slideEl.querySelector(".hero-btn-group");

          // 0. After 0.1s -> Trigger Floating Badge
          const t0 = setTimeout(function () {
            if (badgeEl) {
              badgeEl.classList.add("is-animated");
            }
          }, 100);
          animationTimeouts.push(t0);

          // 0.5. After 0.2s -> Trigger Sub-title
          const tSub = setTimeout(function () {
            if (subTitleEl) {
              subTitleEl.classList.add("is-animated");
            }
          }, 200);
          animationTimeouts.push(tSub);

          // 1. After 0.3s -> Trigger Hero Title character stagger animation
          const t1 = setTimeout(function () {
            if (split && split.chars && split.chars.length) {
              gsap.fromTo(
                split.chars,
                { x: 35, opacity: 0 },
                {
                  x: 0,
                  opacity: 1,
                  duration: 0.65,
                  stagger: 0.025,
                  ease: "power3.out",
                  clearProps: "transform,opacity"
                }
              );
            }
          }, 300);
          animationTimeouts.push(t1);

          // 2. After 0.5s -> Trigger Content / Description
          const t2 = setTimeout(function () {
            if (descEl) {
              descEl.classList.add("is-animated");
            }
          }, 500);
          animationTimeouts.push(t2);

          // 3. After 0.7s -> Trigger Button(s)
          const t3 = setTimeout(function () {
            if (btnGroupEl) {
              btnGroupEl.classList.add("is-animated");
            }
          }, 700);
          animationTimeouts.push(t3);
        }

        if (slideCount <= 1) {
          $swiperContainer.addClass("is-single-slide");
        }

        const isLoop = slideCount > 1;
        const isAutoplay = Boolean(autoplayEnabled) && slideCount > 1;

        const heroSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          loop: isLoop,
          speed: 800,
          effect: effectType,
          fadeEffect: {
            crossFade: true
          },
          autoplay: isAutoplay
            ? {
                delay: autoplaySpeed,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,
          pagination: {
            el: $swiperContainer.find(".hero-pagination")[0] || null,
            clickable: true
          },
          navigation: {
            nextEl: $swiperContainer.find(".hero-btn-next")[0] || null,
            prevEl: $swiperContainer.find(".hero-btn-prev")[0] || null
          },
          on: {
            slideChangeTransitionStart: function (sw) {
              clearSlideTimeouts();
              sw.slides.forEach(function (slide, idx) {
                if (idx !== sw.activeIndex) {
                  resetSlide(slide);
                }
              });
            },
            slideChangeTransitionEnd: function (sw) {
              const activeSlide = sw.slides[sw.activeIndex];
              triggerSlideAnimation(activeSlide);
            }
          }
        });

        // Store reference for Shopify theme customizer events
        swiperEl.swiperInstance = heroSwiper;

        // Animate initial slide once page is ready
        let initialPlayed = false;
        playHeroTitle = function () {
          if (initialPlayed) return;
          initialPlayed = true;
          const activeSlide = heroSwiper.slides[heroSwiper.activeIndex] || $slides[0];
          triggerSlideAnimation(activeSlide);
        };

        if (!$("#spPreloader").length || $("#spPreloader").hasClass("loaded")) {
          setTimeout(playHeroTitle, 200);
        }
        setTimeout(playHeroTitle, 1500);

        // Shopify theme customizer block interaction support
        document.addEventListener("shopify:block:select", function (e) {
          if (heroSwiper && e.target && $swiperContainer[0].contains(e.target)) {
            const slideIndex = $(e.target).closest(".hero-slide").data("slide-index");
            if (typeof slideIndex !== "undefined") {
              if (heroSwiper.autoplay && heroSwiper.autoplay.running) {
                heroSwiper.autoplay.stop();
              }
              if (heroSwiper.params.loop) {
                heroSwiper.slideToLoop(slideIndex);
              } else {
                heroSwiper.slideTo(slideIndex);
              }
            }
          }
        });

        document.addEventListener("shopify:block:deselect", function (e) {
          if (heroSwiper && isAutoplay && heroSwiper.autoplay) {
            heroSwiper.autoplay.start();
          }
        });
      });
    } else {
      // Fallback for single static hero without swiper
      const heroEl = document.querySelector(".hero-title");
      if (heroEl && typeof SplitType !== "undefined") {
        const heroSplit = new SplitType(heroEl, { types: "words, chars" });
        let heroPlayed = false;

        playHeroTitle = function () {
          if (heroPlayed || !heroSplit.chars || !heroSplit.chars.length) return;
          heroPlayed = true;
          setTimeout(function () {
            document.querySelector(".hero-floating-badge")?.classList.add("is-animated");
          }, 100);
          setTimeout(function () {
            document.querySelector(".hero-content .sub-title")?.classList.add("is-animated");
          }, 200);
          setTimeout(function () {
            gsap.from(heroSplit.chars, {
              x: 35,
              opacity: 0,
              duration: 0.65,
              stagger: 0.025,
              ease: "power3.out",
              clearProps: "transform,opacity"
            });
          }, 300);
          setTimeout(function () {
            document.querySelector(".hero-desc")?.classList.add("is-animated");
          }, 500);
          setTimeout(function () {
            document.querySelector(".hero-btn-group")?.classList.add("is-animated");
          }, 700);
        };

        if (!$("#spPreloader").length || $("#spPreloader").hasClass("loaded")) {
          setTimeout(playHeroTitle, 200);
        }
        setTimeout(playHeroTitle, 2200);
      }
    }

    // 2. Section Titles Animation (on scroll via ScrollTrigger)
    document.querySelectorAll(".sec-title, .sec-head .title").forEach(function (el) {
      if (el.classList.contains("hero-title")) return;

      if (typeof SplitType !== "undefined") {
        const split = new SplitType(el, { types: "words, chars" });
        const targets = [...split.chars];
        const icon = el.querySelector(".donate-heart-icon");
        if (icon) targets.push(icon);

        gsap.from(targets, {
          scrollTrigger: {
            trigger: el,
            start: "top 90%",
            once: true
          },
          x: 35,
          opacity: 0,
          duration: 0.65,
          stagger: 0.025,
          ease: "power3.out",
          clearProps: "transform,opacity"
        });
      }
    });
  }


  /* ======================================================
     Mobile Navigation Toggle & Focus Management
     ====================================================== */
  const $mobileToggle = $("#mobileMenuToggle");
  const $mobileDrawer = $("#mobileNavDrawer");
  const $mobileClose = $("#mobileCloseBtn");
  const $shadowOverlay = $("#shadowOverlay");

  let lastActiveTrigger = null;

  function trapFocus($container, event) {
    if (event.key !== "Tab") return;
    const focusable = $container.find('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
    if (!focusable.length) return;
    const first = focusable.first()[0];
    const last = focusable.last()[0];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function openMobileNav() {
    lastActiveTrigger = document.activeElement;
    if (window.lenis) window.lenis.stop();
    $mobileDrawer.addClass("open");
    $("body").addClass("nav-open");
    $mobileToggle.addClass("active").attr("aria-expanded", "true");
    setTimeout(function () {
      $mobileClose.focus();
    }, 100);
  }

  function closeMobileNav() {
    $mobileDrawer.removeClass("open");
    $("body").removeClass("nav-open");
    $mobileToggle.removeClass("active").attr("aria-expanded", "false");
    if (window.lenis && !$("body").hasClass("cart-open") && !$("body").hasClass("search-open")) {
      window.lenis.start();
    }
    if (lastActiveTrigger && typeof lastActiveTrigger.focus === "function") {
      lastActiveTrigger.focus();
      lastActiveTrigger = null;
    }
  }

  $mobileToggle.on("click", function () {
    if ($mobileDrawer.hasClass("open")) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  });

  $mobileClose.on("click", closeMobileNav);
  $shadowOverlay.on("click", function () {
    closeMobileNav();
    closeCartDrawer();
  });
  $(".drawer-nav a, .drawer-cta-btn").on("click", closeMobileNav);

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      if ($mobileDrawer.hasClass("open")) closeMobileNav();
      if (typeof closeCartDrawer === "function" && $("#cartDrawer").hasClass("open")) closeCartDrawer();
      if (typeof closeSearchModal === "function" && $("#searchModal").hasClass("open")) closeSearchModal();
    } else if (e.key === "Tab") {
      if ($mobileDrawer.hasClass("open")) {
        trapFocus($mobileDrawer, e);
      } else if (typeof $cartDrawer !== "undefined" && $cartDrawer.hasClass("open")) {
        trapFocus($cartDrawer, e);
      } else if (typeof $searchModal !== "undefined" && $searchModal.hasClass("open")) {
        trapFocus($searchModal, e);
      }
    }
  });

  /* ======================================================
     Sticky Header (Smooth & No Scroll Layout Shift)
     ====================================================== */
  const $header = $(".header");
  let isSticky = false;
  let isTicking = false;

  function updateStickyHeader() {
    const currentScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

    // Hysteresis: activates at 280px, deactivates at 120px to prevent boundary flicker
    if (currentScrollY > 280) {
      if (!isSticky) {
        isSticky = true;
        document.body.classList.add("sticky-header");
        $header.addClass("is-sticky");
      }
    } else if (currentScrollY < 120) {
      if (isSticky) {
        isSticky = false;
        document.body.classList.remove("sticky-header");
        $header.removeClass("is-sticky");
      }
    }

    // Back to top button
    if (currentScrollY > 350) {
      $(".back-to-top-btn").addClass("show");
    } else {
      $(".back-to-top-btn").removeClass("show");
    }

    isTicking = false;
  }

  /* ======================================================
     Auto-Show Scrollbar ONLY When Scrolling (Zero Glitch)
     ====================================================== */
  let scrollbarTimer = null;
  const $html = $("html");

  function triggerScrollbarVisible() {
    if (!$html.hasClass("is-scrolling")) {
      $html.addClass("is-scrolling");
    }
    if (scrollbarTimer) {
      clearTimeout(scrollbarTimer);
    }
    scrollbarTimer = setTimeout(function () {
      $html.removeClass("is-scrolling");
    }, 1100);
  }

  window.addEventListener("scroll", function () {
    triggerScrollbarVisible();
    if (!isTicking) {
      window.requestAnimationFrame(updateStickyHeader);
      isTicking = true;
    }
  }, { passive: true });

  // Initial check on load in case page is refreshed while scrolled
  updateStickyHeader();

  /* ======================================================
     Back to Top & Anchor Links (Smooth Scroll via Lenis)
     ====================================================== */
  $(".back-to-top-btn").on("click", function (e) {
    e.preventDefault();
    if (window.lenis) {
      window.lenis.scrollTo(0, { duration: 1.2 });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });

  // Smooth scroll for internal hash links (#ranges, #hero, etc.)
  $(document).on("click", 'a[href^="#"]', function (e) {
    const href = $(this).attr("href");
    if (href && href !== "#" && href.startsWith("#")) {
      const $target = $(href);
      if ($target.length) {
        e.preventDefault();
        const offsetTop = $target.offset().top - 80;
        if (window.lenis) {
          window.lenis.scrollTo(offsetTop, { duration: 1.2 });
        } else {
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }
      }
    }
  });








  /* ======================================================
     Dynamic Section Padding via Data Attributes [data-pt] [data-pb] [data-py]
     ====================================================== */
  $("[data-pt], [data-pb], [data-py]").each(function () {
    const $sec = $(this);
    const pt = $sec.attr("data-pt");
    const pb = $sec.attr("data-pb");
    const py = $sec.attr("data-py");

    if (pt !== undefined) $sec.css("--sec-pt", isNaN(pt) ? pt : pt + "px");
    if (pb !== undefined) $sec.css("--sec-pb", isNaN(pb) ? pb : pb + "px");
    if (py !== undefined) {
      $sec.css("--sec-pt", isNaN(py) ? py : py + "px");
      $sec.css("--sec-pb", isNaN(py) ? py : py + "px");
    }
  });

  /* ======================================================
     Reviews Swiper Slider (Scrollable Uniform Cards with Drag & Wheel)
     ====================================================== */
  if ($(".reviews-swiper").length > 0 && typeof Swiper !== "undefined") {
    new Swiper(".reviews-swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      speed: 600,
      grabCursor: true,
      touchAngle: 45,
      touchStartPreventDefault: false,
      pagination: {
        el: ".reviews-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".reviews-btn-next",
        prevEl: ".reviews-btn-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

    /* Mouse drag-to-scroll vertically for review content */
    $(".review-content").each(function () {
      var el = this;
      var isDown = false;
      var startY = 0;
      var startX = 0;
      var initialScrollTop = 0;
      var isVerticalDrag = false;

      $(el).on("mousedown", function (e) {
        if (e.button !== 0) return;
        isDown = true;
        startY = e.pageY;
        startX = e.pageX;
        initialScrollTop = el.scrollTop;
        isVerticalDrag = false;
      });

      $(window).on("mousemove", function (e) {
        if (!isDown) return;
        var dy = e.pageY - startY;
        var dx = e.pageX - startX;

        // If vertical movement exceeds threshold before horizontal, engage vertical scroll
        if (!isVerticalDrag && Math.abs(dy) > 4 && Math.abs(dy) > Math.abs(dx)) {
          isVerticalDrag = true;
        }

        if (isVerticalDrag) {
          el.scrollTop = initialScrollTop - dy;
        }
      });

      $(window).on("mouseup", function () {
        isDown = false;
        isVerticalDrag = false;
      });
    });
  }

  /* ======================================================
     Dynamic Cart & Mini Cart Drawer (Shopify OS 2.0 AJAX Sync)
     ====================================================== */
  const $cartBtn = $("#cartBtn");
  const $cartDrawer = $("#cartDrawer");
  const $cartCloseBtn = $("#cartCloseBtn");
  const $cartBadge = $("#cartBadge");

  // Initial badge check
  const initialBadgeCount = parseInt($cartBadge.text().trim(), 10) || 0;
  if (initialBadgeCount <= 0) {
    $cartBadge.hide().addClass("is-hidden").attr("data-count", "0");
  }

  function openCartDrawer() {
    lastActiveTrigger = document.activeElement;
    closeMobileNav();
    if (typeof closeSearchModal === "function") closeSearchModal();
    if (window.lenis) window.lenis.stop();
    $("#cartDrawer").addClass("open");
    $("body").addClass("cart-open");
    setTimeout(function () {
      $("#cartCloseBtn").focus();
    }, 100);
  }

  function closeCartDrawer() {
    $("#cartDrawer").removeClass("open");
    $("body").removeClass("cart-open");
    if (window.lenis && !$("body").hasClass("nav-open") && !$("body").hasClass("search-open")) {
      window.lenis.start();
    }
    if (lastActiveTrigger && typeof lastActiveTrigger.focus === "function") {
      lastActiveTrigger.focus();
      lastActiveTrigger = null;
    }
  }

  $cartBtn.on("click", function (e) {
    e.preventDefault();
    openCartDrawer();
  });

  $(document).on("click", "#cartCloseBtn", function (e) {
    e.preventDefault();
    closeCartDrawer();
  });

  const ThemeCart = {
    isUpdating: false,
    updateAbortController: null,
    routes: window.themeRoutes || {
      cart_url: '/cart',
      cart_add_url: '/cart/add.js',
      cart_change_url: '/cart/change.js',
      cart_clear_url: '/cart/clear.js'
    },

    openDrawer: openCartDrawer,
    closeDrawer: closeCartDrawer,

    getCartPageSectionId() {
      const el = document.querySelector('[data-section-id].cart-page-sec');
      return el ? el.dataset.sectionId : null;
    },

    async getCart() {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      return await res.json();
    },

    setLoading(loading, $item) {
      this.isUpdating = loading;
      const $drawer = $("#cartDrawer");
      const $pageSec = $(".cart-page-sec");

      if (loading) {
        $drawer.addClass("is-loading");
        $pageSec.addClass("cart-is-updating");
        if ($item && $item.length) {
          $item.addClass("item-updating");
          $item.find(".cart-qty-btn, .cart-item-remove").prop("disabled", true);
        }
      } else {
        $drawer.removeClass("is-loading");
        $pageSec.removeClass("cart-is-updating");
        $(".cart-item").removeClass("item-updating");
        $(".cart-qty-btn, .cart-item-remove, .cart-qty-input").prop("disabled", false);
      }
    },

    async changeItem(key, quantity, $item) {
      if (!key) return;

      if (this.updateAbortController) {
        this.updateAbortController.abort();
      }
      this.updateAbortController = new AbortController();

      this.setLoading(true, $item);

      const cartSectionId = this.getCartPageSectionId();
      const sectionsToRender = ['cart-drawer'];
      if (cartSectionId) {
        sectionsToRender.push(cartSectionId);
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, parseInt(quantity, 10) || 0),
            sections: sectionsToRender
          }),
          signal: this.updateAbortController.signal
        });

        if (!response.ok) {
          throw new Error('Could not update cart line item.');
        }

        const data = await response.json();
        await this.renderCart(data);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Cart update error:', err);
          await this.syncAll();
        }
      } finally {
        this.setLoading(false);
        this.updateAbortController = null;
      }
    },

    async removeItem(key, $item) {
      return this.changeItem(key, 0, $item);
    },

    async addItem(formOrData) {
      this.setLoading(true);
      const cartSectionId = this.getCartPageSectionId();
      const sectionsToRender = ['cart-drawer'];
      if (cartSectionId) {
        sectionsToRender.push(cartSectionId);
      }

      let body;
      let headers = { 'Accept': 'application/json' };

      if (formOrData instanceof HTMLFormElement) {
        const fd = new FormData(formOrData);
        fd.append('sections', sectionsToRender.join(','));
        body = fd;
      } else if (formOrData instanceof FormData) {
        formOrData.append('sections', sectionsToRender.join(','));
        body = formOrData;
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify({
          ...formOrData,
          sections: sectionsToRender
        });
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: headers,
          body: body
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Could not add item to bag.');
        }

        const data = await response.json();
        await this.renderCart(data);
        this.openDrawer();
      } catch (err) {
        console.error('Add to cart error:', err);
        alert(err.message || 'Could not add item to shopping bag.');
      } finally {
        this.setLoading(false);
      }
    },

    async updateNote(note) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ note: note || '' })
        });
      } catch (err) {
        console.error('Error updating cart note:', err);
      }
    },

    async renderCart(data) {
      const cartData = (data && Array.isArray(data.items)) ? data : await this.getCart();
      const sections = (data && data.sections) ? data.sections : {};

      // 1. Update Cart Drawer Section
      if (sections['cart-drawer']) {
        this.updateDrawerHtml(sections['cart-drawer']);
      } else {
        await this.fetchDrawerSection();
      }

      // 2. Update Cart Page Section (if user is on /cart)
      const cartSectionId = this.getCartPageSectionId();
      if (cartSectionId) {
        if (sections[cartSectionId]) {
          this.updateCartPageHtml(sections[cartSectionId], cartSectionId);
        } else {
          await this.fetchCartPageSection(cartSectionId);
        }
      }

      // 3. Update Badges and Counters
      this.updateCounters(cartData.item_count);

      // 4. Dispatch custom cart event
      const event = new CustomEvent('cart:updated', { detail: { cart: cartData } });
      window.dispatchEvent(event);
      document.dispatchEvent(event);
    },

    updateDrawerHtml(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#cartDrawer');
      const currentDrawer = document.querySelector('#cartDrawer');

      if (newDrawer && currentDrawer) {
        const wasOpen = currentDrawer.classList.contains('open');
        currentDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) {
          currentDrawer.classList.add('open');
        }
      }
    },

    updateCartPageHtml(html, sectionId) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const selector = '#section-' + sectionId;
      const newSection = doc.querySelector(selector);
      const currentSection = document.querySelector(selector);

      if (newSection && currentSection) {
        currentSection.replaceWith(newSection);
      }
    },

    async fetchDrawerSection() {
      try {
        const res = await fetch('/?section_id=cart-drawer', { cache: 'no-store' });
        if (res.ok) {
          const html = await res.text();
          this.updateDrawerHtml(html);
        }
      } catch (e) {
        console.warn('Could not fetch drawer section:', e);
      }
    },

    async fetchCartPageSection(sectionId) {
      try {
        const res = await fetch('/cart?section_id=' + encodeURIComponent(sectionId), { cache: 'no-store' });
        if (res.ok) {
          const html = await res.text();
          this.updateCartPageHtml(html, sectionId);
        }
      } catch (e) {
        console.warn('Could not fetch cart page section:', e);
      }
    },

    updateCounters(count) {
      const itemCount = typeof count === 'number' ? count : 0;

      // Update Header Cart Badge
      const $badge = $('#cartBadge');
      if ($badge.length) {
        $badge.attr('data-count', itemCount);
        if (itemCount > 0) {
          $badge.text(itemCount).css('display', 'flex').removeClass('is-hidden');
        } else {
          $badge.text('').css('display', 'none').addClass('is-hidden');
        }
      }

      // Update Header Cart Button Aria Label
      const $btn = $('#cartBtn');
      if ($btn.length) {
        $btn.attr('aria-label', 'Open shopping bag, ' + itemCount + (itemCount === 1 ? ' item' : ' items'));
      }

      // Update Cart Drawer Count
      const $drawerCount = $('#cartDrawerCount');
      if ($drawerCount.length) {
        $drawerCount.text('(' + itemCount + ')');
      }

      // Update Cart Page Count
      const $pageCount = $('.cart-page-count');
      if ($pageCount.length) {
        $pageCount.text('(' + itemCount + (itemCount === 1 ? ' item)' : ' items)'));
      }

      // Universal cart counter elements
      $('[data-cart-count], [data-cart-item-count]').text(itemCount);
      $('.cart-count-bubble, [data-cart-count-bubble]').text(itemCount).toggle(itemCount > 0);
    },

    async syncAll() {
      try {
        const cart = await this.getCart();
        const cartSectionId = this.getCartPageSectionId();
        await this.fetchDrawerSection();
        if (cartSectionId) {
          await this.fetchCartPageSection(cartSectionId);
        }
        this.updateCounters(cart.item_count);
      } catch (err) {
        console.error('Error during ThemeCart.syncAll:', err);
      }
    }
  };

  window.ThemeCart = ThemeCart;

  // Cart Drawer Quantity Buttons (+ / -)
  $(document).on("click", "#cartDrawer .qty-plus", function () {
    const $btn = $(this);
    const $item = $btn.closest(".cart-item");
    const key = $btn.attr("data-key") || $item.attr("data-key");
    const $qtyVal = $item.find(".cart-qty-val");
    let qty = parseInt($qtyVal.text().trim(), 10) || 1;
    qty++;
    $qtyVal.text(qty);
    ThemeCart.changeItem(key, qty, $item);
  });

  $(document).on("click", "#cartDrawer .qty-minus", function () {
    const $btn = $(this);
    const $item = $btn.closest(".cart-item");
    const key = $btn.attr("data-key") || $item.attr("data-key");
    const $qtyVal = $item.find(".cart-qty-val");
    let qty = parseInt($qtyVal.text().trim(), 10) || 1;
    if (qty > 1) {
      qty--;
      $qtyVal.text(qty);
      ThemeCart.changeItem(key, qty, $item);
    } else {
      ThemeCart.removeItem(key, $item);
    }
  });

  // Cart Drawer Item Removal
  $(document).on("click", "#cartDrawer .cart-item-remove", function () {
    const $btn = $(this);
    const $item = $btn.closest(".cart-item");
    const key = $btn.attr("data-key") || $item.attr("data-key");
    ThemeCart.removeItem(key, $item);
  });

  // Intercept Global Add to Cart Form Submissions (e.g. Product Page)
  $(document).on("submit", 'form[action*="/cart/add"]', function (e) {
    e.preventDefault();
    ThemeCart.addItem(this);
  });

  /* ======================================================
     Search Modal (Shopify-Ready)
     ====================================================== */
  const $searchBtn = $("#searchBtn");
  const $searchModal = $("#searchModal");
  const $searchCloseBtn = $("#searchCloseBtn");
  const $searchBackdrop = $("#searchBackdrop");
  const $searchInput = $("#searchModalInput");
  const $searchClearBtn = $("#searchClearBtn");

  function openSearchModal() {
    lastActiveTrigger = document.activeElement;
    closeMobileNav();
    closeCartDrawer();
    if (window.lenis) window.lenis.stop();
    $searchModal.addClass("open");
    $("body").addClass("search-open");
    setTimeout(function () {
      $searchInput.focus();
    }, 150);
  }

  function closeSearchModal() {
    $searchModal.removeClass("open");
    $("body").removeClass("search-open");
    if (window.lenis && !$("body").hasClass("nav-open") && !$("body").hasClass("cart-open")) {
      window.lenis.start();
    }
    if (lastActiveTrigger && typeof lastActiveTrigger.focus === "function") {
      lastActiveTrigger.focus();
      lastActiveTrigger = null;
    }
  }

  $searchBtn.on("click", function (e) {
    e.preventDefault();
    openSearchModal();
  });

  $searchCloseBtn.on("click", closeSearchModal);
  $searchBackdrop.on("click", closeSearchModal);

  $searchInput.on("input", function () {
    if ($(this).val().length > 0) {
      $searchClearBtn.addClass("visible");
    } else {
      $searchClearBtn.removeClass("visible");
    }
  });

  $searchClearBtn.on("click", function () {
    $searchInput.val("").focus();
    $(this).removeClass("visible");
  });

  $("#searchModal .tag-pill").on("click", function () {
    const val = $(this).text().trim();
    $searchInput.val(val).focus();
    $searchClearBtn.addClass("visible");
  });

  /* Search Page Clear Button */
  const $searchPageInput = $("#searchPageInput");
  const $searchPageClearBtn = $("#searchPageClearBtn");
  if ($searchPageInput.length) {
    if ($searchPageInput.val().length > 0) {
      $searchPageClearBtn.addClass("visible");
    }
    $searchPageInput.on("input", function () {
      if ($(this).val().length > 0) {
        $searchPageClearBtn.addClass("visible");
      } else {
        $searchPageClearBtn.removeClass("visible");
      }
    });
    $searchPageClearBtn.on("click", function () {
      $searchPageInput.val("").focus();
      $(this).removeClass("visible");
    });

    $("#searchPageForm").on("submit", function () {
      $(this).find('input[name="type"]').remove();
    });
  }

  /* ======================================================
     Search Page: Instant AJAX Tabs & Pagination (No Reload)
     ====================================================== */
  let isSearchAjaxLoading = false;

  function loadSearchAjaxPage(url, pushState) {
    if (isSearchAjaxLoading || !url) return;
    isSearchAjaxLoading = true;

    const $sec = $("#searchResultsSection");
    const $target = $sec.length ? $sec : $(".search-results-sec");

    $target.addClass("is-loading");

    // Smooth scroll to top of results if user has scrolled down
    if ($target.length && $(window).scrollTop() > $target.offset().top) {
      $("html, body").animate({ scrollTop: Math.max(0, $target.offset().top - 90) }, 250);
    }

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // 1. Seamlessly replace search results section
        const newResults = doc.querySelector("#searchResultsSection");
        const currentResults = document.querySelector("#searchResultsSection");
        if (newResults && currentResults) {
          currentResults.innerHTML = newResults.innerHTML;
        }

        // 2. Update search banner description/count
        const newBannerDesc = doc.querySelector(".search-banner-desc");
        const currentBannerDesc = document.querySelector(".search-banner-desc");
        if (newBannerDesc && currentBannerDesc) {
          currentBannerDesc.innerHTML = newBannerDesc.innerHTML;
        }

        // 3. Update hidden search type input in the search bar
        const newTypeInput = doc.querySelector('form#searchPageForm input[name="type"]');
        let currentTypeInput = document.querySelector('form#searchPageForm input[name="type"]');
        const form = document.querySelector("form#searchPageForm");
        if (newTypeInput && form) {
          if (!currentTypeInput) {
            currentTypeInput = document.createElement("input");
            currentTypeInput.type = "hidden";
            currentTypeInput.name = "type";
            form.appendChild(currentTypeInput);
          }
          currentTypeInput.value = newTypeInput.value;
        } else if (!newTypeInput && currentTypeInput) {
          currentTypeInput.remove();
        }

        const newFieldsInput = doc.querySelector('form#searchPageForm input[name="options[fields]"]');
        let currentFieldsInput = document.querySelector('form#searchPageForm input[name="options[fields]"]');
        if (newFieldsInput && form) {
          if (!currentFieldsInput) {
            currentFieldsInput = document.createElement("input");
            currentFieldsInput.type = "hidden";
            currentFieldsInput.name = "options[fields]";
            form.appendChild(currentFieldsInput);
          }
          currentFieldsInput.value = newFieldsInput.value;
        }

        // 4. Update browser URL history without page reload
        if (pushState !== false && window.history && window.history.pushState) {
          window.history.pushState({ searchUrl: url }, "", url);
        }

        // 5. Refresh animations & smooth scroll
        if (typeof AOS !== "undefined") {
          AOS.refreshHard ? AOS.refreshHard() : AOS.refresh();
        }
        if (window.lenis) {
          window.lenis.resize();
        }
      })
      .catch(function (err) {
        console.warn("AJAX search failed, navigating normally:", err);
        window.location.href = url;
      })
      .finally(function () {
        $target.removeClass("is-loading");
        isSearchAjaxLoading = false;
      });
  }

  // Intercept click on search page tabs
  $(document).on("click", ".search-filter-nav .tab-btn, .js-search-tab-btn", function (e) {
    const $this = $(this);
    const url = $this.attr("href");

    if (!url || url === "#" || url.indexOf("javascript:") === 0) return;

    e.preventDefault();
    if ($this.hasClass("is-active")) return;

    // Fast UI state switch
    $(".search-filter-nav .tab-btn").removeClass("is-active");
    $this.addClass("is-active");

    loadSearchAjaxPage(url, true);
  });

  // Intercept click on search pagination buttons
  $(document).on("click", ".search-pagination a", function (e) {
    const $this = $(this);
    const url = $this.attr("href");

    if (!url || url === "#" || url.indexOf("javascript:") === 0) return;

    e.preventDefault();
    loadSearchAjaxPage(url, true);
  });

  // Listen to browser Back/Forward navigation
  window.addEventListener("popstate", function () {
    if ($("#searchResultsSection").length > 0) {
      loadSearchAjaxPage(window.location.href, false);
    }
  });



  /* ======================================================
     Accessories Swiper Slider
     ====================================================== */
  if ($(".accessories-swiper").length > 0 && typeof Swiper !== "undefined") {
    function checkAccessoriesControls(swiper) {
      if (!swiper) return;
      if (swiper.isLocked) {
        $("#accessoriesControls").hide();
      } else {
        $("#accessoriesControls").css("display", "flex");
      }
    }

    const accessoriesSwiper = new Swiper(".accessories-swiper", {
      slidesPerView: 1,
      spaceBetween: 12,
      watchOverflow: true,
      grabCursor: true,
      speed: 600,
      pagination: {
        el: ".accessories-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".accessories-btn-next",
        prevEl: ".accessories-btn-prev",
      },
      breakpoints: {
        420: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        init: function () {
          checkAccessoriesControls(this);
        },
        update: function () {
          checkAccessoriesControls(this);
        },
        resize: function () {
          checkAccessoriesControls(this);
        },
        breakpoint: function () {
          checkAccessoriesControls(this);
        },
        lock: function () {
          $("#accessoriesControls").hide();
        },
        unlock: function () {
          $("#accessoriesControls").css("display", "flex");
        }
      }
    });

    checkAccessoriesControls(accessoriesSwiper);

    $(window).on("resize", function () {
      if (accessoriesSwiper) {
        checkAccessoriesControls(accessoriesSwiper);
      }
    });
  }

  /* ======================================================
     Product Quantity Selector Controls
     ====================================================== */
  $(document).on("click", ".product-qty-btn.qty-minus", function () {
    const $input = $(this).siblings(".product-qty-input");
    let val = parseInt($input.val(), 10) || 1;
    if (val > 1) {
      $input.val(val - 1).trigger("change");
    }
  });

  $(document).on("click", ".product-qty-btn.qty-plus", function () {
    const $input = $(this).siblings(".product-qty-input");
    let val = parseInt($input.val(), 10) || 1;
    $input.val(val + 1).trigger("change");
  });

  /* ======================================================
     Product Card & Bundle AJAX Add-To-Bag Handler (Shopify)
     ====================================================== */
  $(document).on("click", ".js-ajax-add-to-cart", async function (e) {
    e.preventDefault();

    const $trigger = $(this);
    const $card = $trigger.closest(".product-card, .bundle-action, .product-action-wrap, .product-form");
    let variantId = $card.attr("data-variant-id") || $trigger.attr("data-variant-id");
    if (!variantId) {
      const $form = $trigger.closest("form");
      variantId = $form.find("select[name='id'], input[name='id']").val() || $("input[name='id']").val();
    }

    const $qtyInput = $card.find("input[name='quantity']").length
      ? $card.find("input[name='quantity']")
      : $("input[name='quantity']");
    const quantity = parseInt($qtyInput.val(), 10) || 1;

    const $btn = $card.is(".bundle-action") ? $card.find(".btn") : ($card.find(".arrow-btn").length ? $card.find(".arrow-btn") : $trigger);
    const origText = $btn.text();

    $btn.text("ADDING...").addClass("is-loading").css("pointer-events", "none");

    if (variantId && window.ThemeCart && typeof window.ThemeCart.addItem === "function") {
      try {
        await window.ThemeCart.addItem({ id: variantId, quantity: quantity });
      } catch (err) {
        console.error("AJAX Cart error:", err);
      } finally {
        $btn.text(origText).removeClass("is-loading").css("pointer-events", "");
      }
    } else {
      $btn.text(origText).removeClass("is-loading").css("pointer-events", "");
      console.warn("No variant ID found for product.");
    }
  });

  /* ======================================================
     Shop Page Filter Tabs Handler (Scroll, Redirect, Filter)
     ====================================================== */
  $(document).on("click", ".collection-filter-tabs:not(.blog-filter-tabs) .tab-btn", function (e) {
    const $btn = $(this);
    const targetHref = ($btn.attr("href") || $btn.attr("data-href") || "").trim();
    const filterKey = ($btn.attr("data-filter") || "").toLowerCase().trim();
    const explicitAction = ($btn.attr("data-action") || "").toLowerCase().trim();

    // 1. If explicit URL REDIRECTION or non-anchor link:
    // Allow natural browser navigation directly to the collection page
    if (explicitAction === "redirect" || (targetHref && !targetHref.startsWith("#") && !targetHref.startsWith("javascript:"))) {
      if (targetHref && targetHref !== "#") {
        return; // Natural navigation allowed
      }
    }

    // 2. If SCROLL REDIRECTION or default behavior:
    const isScrollMode = explicitAction === "scroll" || explicitAction === "" || (targetHref && targetHref.startsWith("#"));

    if (isScrollMode && explicitAction !== "filter") {
      let $target = null;

      // Try finding element by direct anchor href
      if (targetHref && targetHref.startsWith("#") && targetHref.length > 1) {
        try {
          const $found = $(targetHref);
          if ($found.length) $target = $found;
        } catch (err) {}
      }

      // Try finding element by collection group, anchor, or semantic match
      if ((!$target || !$target.length) && filterKey) {
        if (filterKey === "all") {
          $target = $("#collectionProducts");
        } else if (filterKey.indexOf("accessori") !== -1) {
          $target = $("#accessoriesSec");
        } else if (filterKey.indexOf("bundle") !== -1) {
          $target = $("#bundleSec");
        } else {
          const cleanKey = filterKey.replace(/-(collection|range)$/i, "");
          const $matched = $(
            "#collection-group-" + filterKey + ", " +
            "#" + filterKey + ", " +
            "[data-filter-group='" + filterKey + "'], " +
            "[data-anchor-id='" + filterKey + "'], " +
            "[data-collection-handle='" + filterKey + "'], " +
            "[data-product-handle='" + filterKey + "'], " +
            "[data-first-product='" + filterKey + "'], " +
            "#collection-group-" + cleanKey + ", " +
            "#" + cleanKey + ", " +
            "[data-filter-group='" + cleanKey + "'], " +
            "[data-collection-handle*='" + cleanKey + "']"
          ).first();

          if ($matched.length) {
            $target = $matched;
          }
        }
      }

      if ($target && $target.length) {
        e.preventDefault();
        $(".collection-filter-tabs .tab-btn").removeClass("is-active").attr("aria-selected", "false");
        $btn.addClass("is-active").attr("aria-selected", "true");

        // Make sure all groups and cards are shown when scrolling directly to one
        const $groups = $(".product-sec .shop-wrap");
        const $accSec = $(".accessories-sec");
        $groups.show();
        $groups.find(".product-card").show();
        $accSec.show();
        $accSec.find(".swiper-slide").show();

        const headerHeight = $(".header").outerHeight() || 80;
        const targetTop = Math.max(0, $target.offset().top - headerHeight - 15);

        if (window.lenis) {
          window.lenis.scrollTo(targetTop, { duration: 1.2 });
        } else {
          $("html, body").animate({ scrollTop: targetTop }, 800, "swing");
        }

        if (window.history && window.history.replaceState && targetHref && targetHref.startsWith("#")) {
          window.history.replaceState(null, null, targetHref);
        }
        return;
      }
    }

    // 3. Fallback: IN-PLACE FILTERING (only when explicit action is filter or no scroll target was matched)
    e.preventDefault();

    $(".collection-filter-tabs .tab-btn").removeClass("is-active").attr("aria-selected", "false");
    $btn.addClass("is-active").attr("aria-selected", "true");

    const $groups = $(".product-sec .shop-wrap");
    const $accSec = $(".accessories-sec");

    if (filterKey === "all" || filterKey === "") {
      $groups.stop(true, true).fadeIn(300);
      $groups.find(".product-card").show();
      $accSec.stop(true, true).fadeIn(300);
      $accSec.find(".swiper-slide").show();
    } else {
      let matchedCount = 0;
      $groups.each(function () {
        const $group = $(this);
        const groupKey = ($group.attr("data-filter-group") || "").toLowerCase().trim();
        const $cards = $group.find(".product-card");

        let groupHasMatch = false;
        $cards.each(function () {
          const $card = $(this);
          const cardTitle = ($card.attr("data-title") || "").toLowerCase();
          const cardHandle = ($card.attr("data-product-handle") || "").toLowerCase();
          const cardFilter = ($card.attr("data-filter") || "").toLowerCase();
          const cardTags = ($card.attr("data-tags") || "").toLowerCase();
          const cardTagHandles = ($card.attr("data-tag-handles") || "").toLowerCase();

          // Check tag lists
          const tagsList = cardTags ? cardTags.split(",").map(function (t) { return t.trim(); }) : [];
          const handlesList = cardTagHandles ? cardTagHandles.split(",").map(function (t) { return t.trim(); }) : [];

          const tagMatched =
            tagsList.indexOf(filterKey) !== -1 ||
            handlesList.indexOf(filterKey) !== -1 ||
            tagsList.some(function (t) { return t && (t.indexOf(filterKey) !== -1 || filterKey.indexOf(t) !== -1); }) ||
            handlesList.some(function (h) { return h && (h.indexOf(filterKey) !== -1 || filterKey.indexOf(h) !== -1); });

          if (
            tagMatched ||
            cardTitle.indexOf(filterKey) !== -1 ||
            cardHandle.indexOf(filterKey) !== -1 ||
            cardFilter.indexOf(filterKey) !== -1 ||
            filterKey.indexOf(cardHandle) !== -1
          ) {
            $card.show();
            groupHasMatch = true;
          } else if (groupKey === filterKey || groupKey.indexOf(filterKey) !== -1 || filterKey.indexOf(groupKey) !== -1) {
            $card.show();
            groupHasMatch = true;
          } else {
            $card.hide();
          }
        });

        if (groupHasMatch || groupKey === filterKey || groupKey.indexOf(filterKey) !== -1 || filterKey.indexOf(groupKey) !== -1) {
          $group.stop(true, true).fadeIn(300);
          matchedCount++;
        } else {
          $group.stop(true, true).hide();
        }
      });

      if ($accSec.length > 0) {
        let accHasMatch = false;
        $accSec.find(".swiper-slide").each(function () {
          const $slide = $(this);
          const $card = $slide.find(".product-card");
          if ($card.length === 0) return;

          const cardTitle = ($card.attr("data-title") || "").toLowerCase();
          const cardHandle = ($card.attr("data-product-handle") || "").toLowerCase();
          const cardFilter = ($card.attr("data-filter") || "").toLowerCase();
          const cardTags = ($card.attr("data-tags") || "").toLowerCase();
          const cardTagHandles = ($card.attr("data-tag-handles") || "").toLowerCase();

          const tagsList = cardTags ? cardTags.split(",").map(function (t) { return t.trim(); }) : [];
          const handlesList = cardTagHandles ? cardTagHandles.split(",").map(function (t) { return t.trim(); }) : [];

          const tagMatched =
            tagsList.indexOf(filterKey) !== -1 ||
            handlesList.indexOf(filterKey) !== -1 ||
            tagsList.some(function (t) { return t && (t.indexOf(filterKey) !== -1 || filterKey.indexOf(t) !== -1); });

          if (
            filterKey.indexOf("accessori") !== -1 ||
            tagMatched ||
            cardTitle.indexOf(filterKey) !== -1 ||
            cardHandle.indexOf(filterKey) !== -1 ||
            cardFilter.indexOf(filterKey) !== -1
          ) {
            $slide.show();
            accHasMatch = true;
          } else {
            $slide.hide();
          }
        });

        if (accHasMatch || filterKey.indexOf("accessori") !== -1) {
          $accSec.stop(true, true).fadeIn(300);
        } else {
          $accSec.stop(true, true).hide();
        }
      }
    }

    if (window.lenis) {
      window.lenis.resize();
    }
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
    if (typeof AOS !== "undefined") {
      AOS.refresh();
    }
  });

  /* ======================================================
     Product Detail Page: Synced Main & Thumbs Swipers
     ====================================================== */
  if ($(".product-main-swiper").length > 0 && typeof Swiper !== "undefined") {
    let productThumbsSwiper = null;
    let productMainSwiper = null;
    let currentMode = null; // 'desktop' or 'mobile'

    function initProductSwipers() {
      const isMobile = window.innerWidth <= 640;
      const targetMode = isMobile ? "mobile" : "desktop";

      // If already initialized in this mode, just update positions
      if (productThumbsSwiper && productMainSwiper && currentMode === targetMode) {
        productThumbsSwiper.update();
        productMainSwiper.update();
        return;
      }

      currentMode = targetMode;

      // Cleanly destroy previous instances
      if (productMainSwiper) {
        productMainSwiper.destroy(true, true);
        productMainSwiper = null;
      }
      if (productThumbsSwiper) {
        productThumbsSwiper.destroy(true, true);
        productThumbsSwiper = null;
      }

      // Reset inline styles on swiper-wrapper and slides to prevent lingering transforms
      $(".product-thumbs-swiper .swiper-wrapper").removeAttr("style");
      $(".product-thumbs-swiper .swiper-slide").removeAttr("style");

      // 1. Vertical (desktop) / Horizontal (mobile) Thumbs Swiper
      productThumbsSwiper = new Swiper(".product-thumbs-swiper", {
        direction: isMobile ? "horizontal" : "vertical",
        slidesPerView: "auto",
        spaceBetween: isMobile ? 10 : 12,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        grabCursor: true,
        freeMode: false,
        observer: true,
        observeParents: true
      });

      // 2. Main Product Image Swiper (Synced with Thumbs)
      productMainSwiper = new Swiper(".product-main-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        grabCursor: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        observer: true,
        observeParents: true,
        thumbs: {
          swiper: productThumbsSwiper,
          slideThumbActiveClass: "swiper-slide-thumb-active"
        }
      });
    }

    // Initialize swipers
    initProductSwipers();

    // Down navigation button advances both slides
    $(document).off("click.galleryNav", "#galleryThumbsDownBtn").on("click.galleryNav", "#galleryThumbsDownBtn", function (e) {
      e.preventDefault();
      if (!productMainSwiper) return;
      if (productMainSwiper.isEnd) {
        productMainSwiper.slideTo(0);
      } else {
        productMainSwiper.slideNext();
      }
    });

    // Handle viewport resize with debounce across 640px threshold
    let resizeTimer = null;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initProductSwipers();
      }, 80);
    });

    $(window).on("load", function () {
      if (productThumbsSwiper) productThumbsSwiper.update();
      if (productMainSwiper) productMainSwiper.update();
    });
  }

  /* ======================================================
     Overview Tabs Switcher
     ====================================================== */
  $(document).on("click", ".overview-tab-btn", function () {
    const $btn = $(this);
    const targetId = $btn.data("tab");
    $btn.addClass("is-active").siblings().removeClass("is-active");
    $btn.attr("aria-selected", "true").siblings().attr("aria-selected", "false");
    $("#" + targetId).addClass("is-active").siblings().removeClass("is-active");
  });

  /* ======================================================
     URL Hash Deep-link Scroll on Page Load
     ====================================================== */
  if (window.location.hash && window.location.hash.length > 1) {
    setTimeout(function () {
      try {
        const hash = window.location.hash;
        const $hashTarget = $(hash);
        if ($hashTarget.length) {
          const headerHeight = $(".header").outerHeight() || 80;
          const targetTop = Math.max(0, $hashTarget.offset().top - headerHeight - 15);
          if (window.lenis) {
            window.lenis.scrollTo(targetTop, { duration: 1.2 });
          } else {
            $("html, body").animate({ scrollTop: targetTop }, 800, "swing");
          }
          $(".collection-filter-tabs .tab-btn").each(function () {
            const $tab = $(this);
            const tabHref = $tab.attr("href") || $tab.attr("data-href");
            if (tabHref === hash) {
              $(".collection-filter-tabs .tab-btn").removeClass("is-active").attr("aria-selected", "false");
              $tab.addClass("is-active").attr("aria-selected", "true");
            }
          });
        }
      } catch (e) {}
    }, 350);
  }

});

